import React from 'react';

import { i18n } from '@lt/localization';

import OrderError from 'src/components/OrderError';
import type { PropsFromRedux } from '.';
import { ERROR_TYPE } from '../../../../store/error/constants';

export const ErrorPopup = ({
  isOpened,
  closePopup,
  message = i18n.t('checkout.error.unknown'),
  type = null,
  orderId = null,
  goToOrder,
  partnerContactPhone,
}: PropsFromRedux): JSX.Element | null => {
  const { t } = i18n;

  const isTypeOrder =
    type === ERROR_TYPE.ORDER || type === ERROR_TYPE.ORDER_3DS;
  return (
    <OrderError
      message={message || ''}
      title={
        isTypeOrder ? t('checkout.error.writeOff') : t('checkout.error.title')
      }
      onRetry={closePopup}
      goToOrder={goToOrder}
      orderNumber={orderId ?? undefined}
      contactPhone={partnerContactPhone ?? undefined}
      isOpened={isOpened}
      closePopup={closePopup}
    />
  );
};
